export default __webpack_public_path__ + "static/research-25e5f304646a6fdee640d80691d79755.png";